module.exports = __webpack_public_path__ + "static/img/mine_active.7e74bf72.png";